import 'sos-common/js/utils/polyfills';
import * as Components from './components';
import ReactModal from 'react-modal';

import React from 'react';
import ReactDOM from 'react-dom';
import ReactDOMServer from 'react-dom/server';

export {Components};

global["React"] = React;
global["ReactDOM"] = ReactDOM;
global["ReactDOMServer"] = ReactDOMServer;
global["SOS"] = { Components: Components};

window.addEventListener('load', () => {
    ReactModal.setAppElement('main');
});
